const SCHEDULE_BASE = {
    0: { active: false, time: [{ start: '0000', end: '0000' }], },
    1: { active: false, time: [{ start: '0000', end: '0000' }], },
    2: { active: false, time: [{ start: '0000', end: '0000' }], },
    3: { active: false, time: [{ start: '0000', end: '0000' }], },
    4: { active: false, time: [{ start: '0000', end: '0000' }], },
    5: { active: false, time: [{ start: '0000', end: '0000' }], },
    6: { active: false, time: [{ start: '0000', end: '0000' }], }
}

export const USER_PAYMENT_PROVIDERS = {
    mercadopago: 'mercadopago'
}

export const USER_PAYMENTS_FRECUENCY = {
    monthly : 'monthly',
    annual: 'annual'
}

export const USER_PLANS = {
    free: 'free',
    pro: 'pro'
}

export const PAYMENT_METHODS = {
    mercadopago: 'mercadopago',
    transfer: 'transfer',
    cash: 'cash',
}

export const DELIVERY_METHODS = {
    takeaway: 'takeaway',
    delivery: 'delivery',
    inPlace: 'inPlace'
}

export const OPTIONS_VARIANTS = {
    addUnits: 'addUnits',
    selectOption: 'selectOption',
}

export const SCHEDULE_OPTIONS = {
    closed: 'closed',
    openAllDay: 'openAllDay',
    customSchedule: 'customSchedule'
}

export const STORE_STATES = {
    open: 'open',
    openSinceYesterday: 'openSinceYesterday',
    openAllDay: 'openAllDay',
    alreadyClose: 'alreadyClose',
    notOpenYet: 'notOpenYet',
    dayOff: 'dayOff',
}

export function createUser(menuID) {
    return {
        menuid: menuID,
        payments: {
            pro: {
                mercadopago: {
                    monthly: { id: '', paymentLink: '' }, //preapproval_plan_init_point
                    annual: { id: '', paymentLink: '' }, //preapproval_plan_init_point
                }
            }
        },
        plan: {
            type: 'free', // free / pro
            frecuency: 1, // number in months
            provider: { providerID: '', subscriptionID: '' }, // mercadopago
            status: '', // authorized / paused / cancelled / pending
            lastUpdate: Math.floor(Date.now() / 1000) // unix datetime
        }
    }
}

export function createMenu(userID, menuID) {
    return (
        {
            userid: userID,
            plan: {
                type: 'free',
                lastUpdate: Math.floor(Date.now() / 1000),
            },
            phoneNumber: '',
            title: '',
            address: '',
            description: '',
            color: -1,
            logoImgURL: '',
            coverImgURL: '',
            theme: '',
            disabled: false,
            message: { msg: '', schedule: SCHEDULE_BASE },
            schedule: {
                delivery: SCHEDULE_BASE,
                takeaway: SCHEDULE_BASE,
            },
            socialMedia: {
                fb: '',
                tw: '',
                ig: '',
            },
            categories: {},
            products: {},
            offers: [],
            store: {
                removedProducts: {},
                addedProducts: {},
                priceChange: 0,
            },
            deliveryCost: { from: -1, to: -1, free: -1 },
            deliveryOptions: [],
            paymentOptions: [],
        }
    )
}

export function createSocialAccount(platform, account) {
    return (
        {
            platform: platform,
            account: account
        }
    )
}

export function createCategory(id, name, caption) {
    return (
        {
            id: id,
            name: name,
            caption: caption
        }
    )
}

export function createProduct(name, caption, category, price, stock, options, featured, calories) {
    return (
        {
            name: name,
            category: category,
            caption: caption,
            price: price,
            stock: stock,
            options: options, // productType
            featured: featured,
            calories: calories,
        }
    )
}

export function createProductOptions(title, options) {
    return (
        {
            title: title,
            isMandatory: false,
            isHidden: false,
            elegibleOptions: 1,
            options: options
        }
    )
}

export function createOption(name, extraPrice, calories) {
    return ({
        name: name,
        extraPrice: extraPrice,
        calories: calories,
    })
}
